import Model, { toModels, toProp } from "./Model";
import HumanName from "./HumanName";
import { capitalize } from "../plugins/uniweb";

/**
 *
 * @class Patient
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.3] app/src/model/Patient.js
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

class Patient extends Model {
  constructor(modelData) {
    super()

    /** @type string */
    this.id = toProp()

    /** @type Number */
    this.patientId = toProp()

    /** @type string|null */
    this.birthdate = toProp()

    /** @type string|null */
    this.gender = toProp()

    /** @type HumanName[]|null */
    this.name = toModels(HumanName)

    /** @type Number|null */
    this.targetWeightValue = toProp()

    /** @type string|null */
    this.targetWeightUnit = toProp()

    this.buildModel(modelData)
  }

  /**
   * get the full official name of the patient
   * @return {string|null}
   */
  getFullOfficialName(){
    this.checkProps('name.use', 'name.given', 'name.family')

    for (let i=0; i<this.name.length; i++)
      if (this.name[i].use === 'official')
        return capitalize(this.name[i].given.join(" ") + " " + this.name[i].family)

    return null
  }

  /**
   * get the first name of the patient
   * @return {string|null}
   */
  getFirstName(){
    this.checkProps('name.use', 'name.given')

    for (let i=0; i<this.name.length; i++)
      if (this.name[i].use === 'official'){
        if (this.name[i].given.length){
          return this.name[i].given[0]
        }else{
          return null
        }
      }
    return null
  }

  /**
   * get the last name of the patient
   * @return {string|null}
   */
  getLastName(){
    this.checkProps('name.family')

    for (let i=0; i<this.name.length; i++)
      if (this.name[i].use === 'official'){
        if (this.name[i].family.length){
          return this.name[i].family;
        }else{
          return null
        }
      }
    return null
  }

  // TODO base format on language settings?
  /**
   * gets the birthdate of the patient formatted for display
   * @return {string|null}
   */
  getBirthdateFormatted(){
    this.checkProps('birthdate')

    if (this.birthdate === null){
      return this.birthdate;
    }else{
      return `${this.birthdate.substr(8,2)}/${this.birthdate.substr(5,2)}/${this.birthdate.substr(0,4)}`
    }
  }

  /**
   * gets the description of the patient inside the search entry box
   * @return {string}
   */
  getSearchEntryText(){
    return `${this.getFullOfficialName()} (${this.getBirthdateFormatted()})`
  }
}

export default Patient